export default __webpack_public_path__ + "static/media/salad.d878857d.jpg";